if (!customElements.get('concours-new-countdown')) {
  customElements.define(
    'concours-new-countdown',
    class ConcoursNewCountdown extends HTMLElement {
      connectedCallback() {
        this.values = {
          days: this.querySelector('[data-unit="days"]'),
          hours: this.querySelector('[data-unit="hours"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          seconds: this.querySelector('[data-unit="seconds"]'),
        };

        this.deadline = this.readDeadline(this.dataset.target, this.dataset.timezone);
        if (!this.deadline) return;

        this.render();
        this.timer = setInterval(() => this.render(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      readDeadline(value, timeZone) {
        if (!value) return null;

        const [datePart, timePart] = value.trim().split(/[T ]/);
        const numbers = datePart.split(/[-/.]/).map(Number);
        const [year, month, day] = numbers[0] > 31 ? numbers : [...numbers].reverse();
        const [hours, minutes] = (timePart || '00:00').split(':').map(Number);
        if (!year || !month || !day) return null;

        const naive = Date.UTC(year, month - 1, day, hours || 0, minutes || 0);
        try {
          return naive - this.zoneOffset(naive, timeZone);
        } catch {
          return naive - this.zoneOffset(naive, 'America/Toronto');
        }
      }

      zoneOffset(timestamp, timeZone) {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone,
          hour12: false,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        }).formatToParts(new Date(timestamp));

        const read = (type) => Number(parts.find((part) => part.type === type).value);

        return (
          Date.UTC(read('year'), read('month') - 1, read('day'), read('hour') % 24, read('minute')) -
          timestamp
        );
      }

      render() {
        const remaining = Math.max(0, this.deadline - Date.now());
        const seconds = Math.floor(remaining / 1000);

        this.values.days.textContent = this.pad(Math.floor(seconds / 86400));
        this.values.hours.textContent = this.pad(Math.floor(seconds / 3600) % 24);
        this.values.minutes.textContent = this.pad(Math.floor(seconds / 60) % 60);
        this.values.seconds.textContent = this.pad(seconds % 60);

        if (remaining === 0) {
          this.classList.add('concours-new-countdown--expired');
          clearInterval(this.timer);
        }
      }

      pad(value) {
        return String(value).padStart(2, '0');
      }
    }
  );
}
